import { atom } from 'recoil';
import { paymentFrequencyMap } from '../../utils/currencyUtil';
import type { UpdatePaymentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/payment/';

export const updatedPaymentInformationAtom = atom<UpdatePaymentDTO>({
    key: 'updatedPaymentInformation',
    default: {
        jobId: '',
        selectedPaymentFrequency: paymentFrequencyMap.monthly,
        paymentMethod: ''
    }
});
